export const TARIFA_2_0_TD = '018';
export const TARIFA_3_0_TD = '019';
export const TARIFA_6_1_TD = '020';
export const TARIFA_6_2_TD = '021';
export const TARIFA_6_3_TD = '022';
export const TARIFA_6_4_TD = '023';
